import React,{useRef, useState, useEffect} from "react";
import { Button, Row, Col, Form} from "react-bootstrap";

class ServiceBar extends React.Component {

	
	
	constructor(props) {
		
		super(props);

		this.fb = React.createRef();
		
		this.state = {
			variant: this.props.variant,
			icon: this.props.iconIdle,
			btnClassName: this.props.btnClassName,
			injectedContent : []
		};
		this.currentContent = [];
	}


	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
	}
	handleToggle(e){
		
		e.target.parentNode.classList.toggle("tuck");
		
		var id = setInterval(()=>{this.props.map.resize()},25);
		
		setTimeout(()=>{clearInterval(id)},510);
	}
	
	inject(content, tab){
		
		if(Number.isInteger(tab)){
			var n = [...this.currentContent];
			n[tab] = content;
		}
		else
			var n = [...this.currentContent, content];
		
		this.currentContent = n;
		
		this.updateStatus({injectedContent:this.currentContent});
		
		return tab ?? this.currentContent.length-1;
	}
	clear(tabIndex){
		
		if(!Number.isInteger(tabIndex)){
			this.currentContent = []
			return this.updateStatus({injectedContent: this.currentContent});
		}
		
		if(!this.currentContent.length || !this.currentContent[tabIndex])
			return;
		
		var n = this.currentContent.slice(0);
		
		n.splice(tabIndex, 1);
		
		this.currentContent = n;
		this.updateStatus({injectedContent: this.currentContent});
	}



	render() {
		
		const idx = this.props.content.findIndex((item)=>{
			if(this.props.map)
				setTimeout(()=>{this.props.map.resize()},510);
			return !!item.content;
		});
		
		return (
			<div className="service-bar-wrp" style={{width:'395px'}}>
				<div className="toggle" onClick={(e)=>this.handleToggle(e)}></div>
				
				<div className="service-bar">
					{
						this.state.injectedContent.length ? this.state.injectedContent[this.state.injectedContent.length - 1] : this.props.children
					}
					{
						this.props.content[idx] ? this.props.content[idx].content : ''
					}
					
					
					
				</div>
			</div>
		);
	}
}

export default ServiceBar;